// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nPyx2FCJOU6LhIj9ogw2 {
  display: flex;
  flex-direction: row;
  position: relative;
  column-gap: 8px;
}
.nPyx2FCJOU6LhIj9ogw2 svg {
  display: none;
  transition: all 0.3s ease-in-out;
}

.Tky56gyOxCVpbYleE8gR {
  transition: all 0.3s ease-in-out;
  display: flex;
  cursor: pointer;
}

.FFGdjDME8MXgNTTKS2ro {
  color: #C4C4C4;
  font-size: 14px;
  font-family: "Chakra Petch";
  text-transform: uppercase;
  margin-left: 8px;
}
@media (max-width: 1000px) {
  .FFGdjDME8MXgNTTKS2ro {
    font-size: 12px;
  }
}

.Fewk1oCxa4ErviB3ZGe6 {
  appearance: none;
  padding: 8px;
  border-radius: 4px;
  height: 20px;
  width: 20px;
  border: 2px solid #c4c4c4;
  transition: all 0.3s ease-in-out;
}
.Fewk1oCxa4ErviB3ZGe6:checked {
  border: 2px solid white;
  background-color: white;
}
.Fewk1oCxa4ErviB3ZGe6:checked ~ .Tky56gyOxCVpbYleE8gR {
  color: white;
}
.Fewk1oCxa4ErviB3ZGe6:checked ~ svg {
  display: block;
  position: absolute;
  left: 6px;
  top: 8px;
  fill: black;
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkbox/Checkbox.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,mBAAA;EAGA,kBAAA;EACA,eAAA;AAHD;AAIC;EACC,aAAA;EACA,gCAAA;AAFF;;AAMA;EACC,gCAAA;EACA,aAAA;EAEA,eAAA;AAJD;;AAOA;EACC,cAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AAJD;AAKC;EAND;IAOE,eAAA;EAFA;AACF;;AAKA;EACC,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;AAFD;AAKC;EACC,uBAAA;EACA,uBAAA;AAHF;AAKE;EACC,YAAA;AAHH;AAME;EACC,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AAJH","sourcesContent":["\r\n\r\n.inputContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\r\n\r\n\tposition: relative;\r\n\tcolumn-gap: 8px;\r\n\t& svg {\r\n\t\tdisplay: none;\r\n\t\ttransition: all 0.3s ease-in-out;\r\n\t}\r\n}\r\n\r\n.label {\r\n\ttransition: all 0.3s ease-in-out;\r\n\tdisplay: flex;\r\n\r\n\tcursor: pointer;\r\n}\r\n\r\n.labelText {\r\n\tcolor: #C4C4C4;\r\n\tfont-size: 14px;\r\n\tfont-family: \"Chakra Petch\";\r\n\ttext-transform: uppercase;\r\n\tmargin-left: 8px;\r\n\t@media (max-width: 1000px) {\r\n\t\tfont-size: 12px;\r\n\t}\r\n}\r\n\r\n.input {\r\n\tappearance: none;\r\n\tpadding: 8px;\r\n\tborder-radius: 4px;\r\n\theight: 20px;\r\n\twidth: 20px;\r\n\tborder: 2px solid #c4c4c4;\r\n\ttransition: all 0.3s ease-in-out;\r\n\r\n\r\n\t&:checked {\r\n\t\tborder: 2px solid white;\r\n\t\tbackground-color: white;\r\n\r\n\t\t& ~ .label {\r\n\t\t\tcolor: white;\r\n\t\t}\r\n\r\n\t\t& ~ svg {\r\n\t\t\tdisplay: block;\r\n\t\t\tposition: absolute;\r\n\t\t\tleft: 6px;\r\n\t\t\ttop: 8px;\r\n\t\t\tfill: black;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `nPyx2FCJOU6LhIj9ogw2`,
	"label": `Tky56gyOxCVpbYleE8gR`,
	"labelText": `FFGdjDME8MXgNTTKS2ro`,
	"input": `Fewk1oCxa4ErviB3ZGe6`
};
export default ___CSS_LOADER_EXPORT___;
